import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Button, CircularProgress, Stack } from "@mui/material";

export default function StockCountDetailActions({
  canApprove = false,
  approveDisabled = false,
  approving = false,
  disabled = false,
  onApprove,
}) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      sx={{
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "flex-end",
      }}
    >
      {canApprove ? (
        <Button
          type="button"
          variant="contained"
          disabled={disabled || approving || approveDisabled}
          onClick={onApprove}
          startIcon={
            approving ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CheckCircleOutlineIcon />
            )
          }
          sx={{
            minWidth: 190,
            height: 38,
            borderRadius: "33px",
            textTransform: "none",
            fontWeight: 800,
          }}
        >
          {approving ? "Integrando..." : "Aprobar e integrar"}
        </Button>
      ) : null}
    </Stack>
  );
}
